import { Dialog, styled } from '@mui/material';
import { PinnacleDialogProps } from './PinnacleDialog.types';

const StyledPinnacleDialog = styled(Dialog)<PinnacleDialogProps>(
  ({ theme }) => ({
    '& .MuiPaper-root': {
      margin: '32px 16px',
      borderRadius: '8px',
      backgroundColor: '#fff', // 🔥 Use white for light mode
    },
    '& .MuiDialogContent-root': {
      padding: '24px',
    },
    '& .MuiAutocomplete-popper .MuiPaper-root': {
      margin: 0,
      borderRadius: 0,
      padding: 0,
    },
    '& .btnCloseModal svg': {
      color: theme.palette.grey[800],
    },
    '& .headerTitle': {
      textAlign: 'center',
      textTransform: 'lowercase',

      ':first-letter': {
        textTransform: 'capitalize',
      },
    },
  }),
);

export default StyledPinnacleDialog;
